import { useEffect, useState } from 'react';
import { MARKET_CHART_DAYS, trimMarketData } from '../marketDataUtils';

const fetch = global.fetch;
const API_BASE = 'https://api.jashsoft.com/marketdata';

function useMarketData(endpoint) {
  const [state, setState] = useState({
    dates: [],
    series: [],
    loading: Boolean(endpoint),
    error: null
  });

  useEffect(() => {
    if (!endpoint) {
      return undefined;
    }

    let cancelled = false;
    setState((prev) => ({ ...prev, loading: true, error: null }));

    fetch(`${API_BASE}/${endpoint}`)
      .then((response) => response.json())
      .then((parsedResponse) => {
        if (cancelled) {
          return;
        }
        const { dates, series } = trimMarketData({
          dates: parsedResponse.dates || [],
          series: parsedResponse.prices || [],
          days: MARKET_CHART_DAYS
        });
        setState({
          dates,
          series,
          loading: false,
          error: null
        });
      })
      .catch(() => {
        if (cancelled) {
          return;
        }
        setState({
          dates: [],
          series: [],
          loading: false,
          error: true
        });
      });

    return () => {
      cancelled = true;
    };
  }, [endpoint]);

  return state;
}

export default useMarketData;
